import { SyntheticEvent } from 'react';
import {
  IDResource,
  IDResourcesState,
  IScholars,
  IScholarsState,
  IUser,
  LiteracyModalResult,
} from 'types';
import DefaultDigitalResourceIcon from 'style/imgs/digital-resource-icon.png';

export enum ResourcesType {
  Math = 'math', // EventTypes.math,
  Science = 'science', // EventTypes.science,
  LanguageArts = 'language arts', // EventTypes.languageArts,
  Art = 'art', // EventTypes.art,
  Social = 'social', // EventTypes.socialStudies,
  Tech = 'technology skills',
  Miscellaneous = 'miscellaneous',
}

export default [
  { id: ResourcesType.Math, label: 'Math' },
  { id: ResourcesType.Science, label: 'Science' },
  { id: ResourcesType.LanguageArts, label: 'Language Arts' },
  { id: ResourcesType.Art, label: 'Art' },
  { id: ResourcesType.Social, label: 'Social Studies' },
  { id: ResourcesType.Tech, label: 'Technology skills' },
  { id: ResourcesType.Miscellaneous, label: 'Miscellaneous' },
];

export type DigitalResourcesMapProps = {
  resourcesState: IDResourcesState;
  userData: IUser | null | undefined;
  scholars: IScholarsState;
  literacyModalResult: LiteracyModalResult;
};

export type HomeroomProps = {
  literacyModalResult: LiteracyModalResult;
  scholar: IScholars | null;
  dRMapLinkElements: React.ReactNode;
};

export function getDiff(
  base: IDResource[],
  updated: IDResource[]
): IDResource[] {
  return updated.filter(
    (r) => (base || []).findIndex((br) => br.id === r.id) < 0
  );
}

type Split = { [key in ResourcesType]: IDResource[] };
export function splitResources(resources: IDResource[]): Split {
  const split: Split = {
    [ResourcesType.Math]: [],
    [ResourcesType.LanguageArts]: [],
    [ResourcesType.Science]: [],
    [ResourcesType.Art]: [],
    [ResourcesType.Social]: [],
    [ResourcesType.Tech]: [],
    [ResourcesType.Miscellaneous]: [],
  };

  if (resources) {
    resources.forEach((r) => {
      const type = r.type as ResourcesType;

      if (r.type) {
        split[type]?.push(r);
      }
    });
  }

  return split;
}

export function formatLink(url: string): string {
  const https = 'https://';
  const http = 'http://';

  if (!url?.startsWith(https) && !url?.startsWith(http)) {
    const str = https + url;

    return str;
  }

  return url;
}

const getHostname = (url: string) => {
  const newUrl = new URL(url);

  return newUrl.hostname;
};

export function getPictureByUrl(url?: string): string {
  if (!url) {
    return '';
  }

  const formattedURL = formatLink(url);
  const finalURL = `${formatLink(getHostname(formattedURL))}/favicon.ico`;
  // Logger('getPictureByUrl returns', finalURL);

  return finalURL;
}

export function onFaviconError(
  e: SyntheticEvent<SVGImageElement, Event>
): void {
  const target = e.target as SVGImageElement;

  target.setAttribute('href', DefaultDigitalResourceIcon);
}

export function clamp(a: number, b: number, c: number): number {
  return Math.max(b, Math.min(c, a));
}
